module.exports = __webpack_public_path__ + "img/PN.ec53b074.svg";